import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FolderTypeRadioButton from './FolderTypeRadioButton';
import { FolderType } from './types';
import DollarPriceInput from '../../../../DollarPriceInput';
import { dollarsToPoints } from '../../../../utils/points';
import s from './PremiumForm.scss';
export var PremiumForm = function (_a) {
    var folderType = _a.folderType, priceInPoints = _a.priceInPoints, onlyNewPaidFolders = _a.onlyNewPaidFolders, coreLevel = _a.coreLevel, onFolderTypeChange = _a.onFolderTypeChange, onSetPriceInPoints = _a.onSetPriceInPoints, onSetError = _a.onSetError;
    var t = useTranslation().t;
    var _b = useState(), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = useState(''), price = _c[0], setPrice = _c[1];
    var isSelected = function (value) { return value === folderType; };
    var onChangePrice = useCallback(function (value, errorMsg) {
        if (!value || !!errorMsg) {
            return;
        }
        onSetPriceInPoints(dollarsToPoints(value));
    }, [onSetPriceInPoints]);
    return (React.createElement("div", { className: s['root'] },
        !onlyNewPaidFolders && (React.createElement(React.Fragment, null,
            React.createElement(FolderTypeRadioButton, { value: FolderType.REGULAR, title: t('mediapopup.newFolderPopup.gallery.radioButtons.regularFolder.label'), hint: t('mediapopup.newFolderPopup.gallery.radioButtons.regularFolder.hint'), onChange: onFolderTypeChange, isSelected: isSelected }),
            React.createElement(FolderTypeRadioButton, { value: FolderType.WATCHERS, title: t('mediapopup.newFolderPopup.gallery.radioButtons.watchersOnly.label'), hint: t('mediapopup.newFolderPopup.gallery.radioButtons.watchersOnly.hint'), onChange: onFolderTypeChange, isSelected: isSelected }),
            React.createElement(FolderTypeRadioButton, { value: FolderType.PAID, title: t('mediapopup.newFolderPopup.gallery.radioButtons.paid.label'), hint: t('mediapopup.newFolderPopup.gallery.radioButtons.paid.hint'), onChange: onFolderTypeChange, isSelected: isSelected }))),
        folderType === 'paid' && (React.createElement(DollarPriceInput, { className: s['price-input'], value: price, errorMessage: errorMessage, onChange: function (value, errorMsg) {
                setPrice(value);
                onChangePrice(+value, errorMsg);
                setErrorMessage(errorMsg);
                onSetError(!!errorMsg);
            } }))));
};
PremiumForm.displayName = 'PremiumForm';
export default PremiumForm;
//# sourceMappingURL=PremiumForm.js.map